import { parseISO } from "date-fns";
import type {
    PatPermission,
    PersonalAccessToken,
} from "@common/schemas/domains/personalAccessToken/personal-access-token.schema";

export function formatPermissions(permissions: PatPermission[]): string {
    const hasWrite = permissions.includes("write");
    const hasRead = permissions.includes("read") || hasWrite;
    if (hasWrite) {
        return "Read & write";
    }
    if (hasRead) {
        return "Read-only";
    }
    return "-";
}

export function tokenStatus(token: PersonalAccessToken): string {
    if (token.revokedAt) {
        return "Revoked";
    }
    if (token.expiresAt) {
        const expiresAt =
            typeof token.expiresAt === "string"
                ? parseISO(token.expiresAt)
                : token.expiresAt;
        if (expiresAt.getTime() < Date.now()) {
            return "Expired";
        }
    }
    return "Active";
}
